import React, { useState } from "react";
import API from "API";
import toastr from "toastr";
import { Button, Form, Input } from "antd";
import { getCookie, removeCookie, setCookie } from "general_function";
import { useNavigate, useSearchParams } from "react-router-dom";
import ConfirmPassword from "./ConfirmPassword";

const onFinishFailed = (error) => {
    console.log(error);
};

export default function ForgetPassword() {
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const navigate = useNavigate();
    const postForgetPassword = async  (
        data,
        message = ""
    ) => {
        if (getCookie("usertoken")) {
            removeCookie("usertoken");
        }
        if (!loading) setLoading(true);
        API.post("forget-password/", data)
            .then((res) => {
                setCookie("usertoken", null);
                toastr.success(message);
                if (token) navigate("/login");
            })
            .catch((error) => {
                if (error.response?.status === 400) {
                    let errorMessage = "";
                    if (error.response?.data?.error === "Token has expired") {
                        errorMessage = "Token đã hết hạn";
                    }

                    if (error.response?.data?.error === "Token is invalid") {
                        errorMessage = "Token không hợp lệ";
                    }
                    if (error.response?.data?.error === "User doesn't exits") {
                        errorMessage = "Email này chưa được đăng ký trên hệ thống";
                    }
                    toastr.error(errorMessage);
                }
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    return <>
        {token ? (
            <ConfirmPassword
                token={token}
                postForgetPassword={postForgetPassword}
                loading={loading}
            />
        ) : (
            <div
                className="d-flex align-items-center"
                style={{ minHeight: "calc(100vh - 64px)" }}
            >
                <div
                    className="bg-white p-4 mx-auto shadow-lg align-center"
                    style={{
                        maxWidth: "420px",
                        borderRadius: "8px",
                        flexGrow: "1",
                    }}
                >
                    <div className="row row-cols-1 row-cols-sm-2 justify-content-between mx-0 align-items-center">
                        <h4 className="mx-0 px-0">Quên mật khẩu</h4>
                        <div
                            style={{ width: "60px" }}
                            className="d-flex justify-content-center"
                        >
                            <img
                                alt="logo"
                                src={
                                    process.env.PUBLIC_URL +
                                    "/img/logo.png"
                                }
                                width="60px"
                            />
                        </div>
                    </div>
                    <div className="mt-3">
                        Lấy lại mật khẩu của hệ thống học tập
                    </div>
                    <Form
                        name="forget-password"
                        className="mt-3"
                        layout="vertical"
                        labelCol={{
                            span: 24,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        style={{
                            maxWidth: 600,
                            margin: "auto",
                        }}
                        initialValues={{
                            remember: true,
                        }}
                        onFinish={(values) => {
                            if (loading) return;
                            postForgetPassword(
                                values,
                                "Gửi email lấy lại mật khẩu thành công"
                            );
                        }}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Nhập email!",
                                },
                                {
                                    type: "email",
                                    message:
                                        "Nhập email không đúng định dạng!",
                                },
                            ]}
                        >
                            <Input disabled={loading} />
                        </Form.Item>

                        <Form.Item label={null} className="mb-0">
                            <Button
                                className="w-100 px-0 mx-0"
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                            >
                                Gửi
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        )}
    </>
}
